import { render } from "./SubsidiesTable.vue?vue&type=template&id=016b3697"
import script from "./SubsidiesTable.vue?vue&type=script&lang=js"
export * from "./SubsidiesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__